import type { TBlueTable } from "@app/types/insider";
import { mapListItem } from "@app/statefx/routines/mapperfn-listdefinition";
import {
  epBuilderAll,
  epBuilderAnyIssuerNoSlices,
} from "@app/statefx/routines/mapperfn-pathbuilder";
import { ILxReportOption } from "@app/types/insider";

export const listModels: TBlueTable<ILxReportOption> = {
  name: "listsModels",
  initialState: {},
  empty: {} as ILxReportOption,
  primaryKey: "id",
  apiUrl: "/reports/listreportdetails",
  urlPathBuilder: epBuilderAnyIssuerNoSlices,
  mapWrite: mapListItem,
  pkeyUrl: null,
  starfx: true,
  starfx_index: "id",
  idb: false,
  bootPriority: 0,
  onmru: "no",
  oncsdb: "full",
  label: "Liste rapoarte",
  appContext: [],
};
